// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2w7u9","sendOtp":"AuthorizeToLogin_sendOtp__3oaQP"};